
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5s27v", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("eLeAP"))).ShortcutsSection
});


/**
 * @generated SignedSource<<543e833df781031af9ce80858ee022c6>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba
const $4d55e7bf74ef8f79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
            "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
            "metadata": {},
            "name": "SpaceViewsControllerQuery",
            "operationKind": "query",
            "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$4d55e7bf74ef8f79$var$node.hash = "d33ab2e8cd8e66319f41302e5bdaa679";
var $4d55e7bf74ef8f79$export$2e2bcd8739ae039 = $4d55e7bf74ef8f79$var$node;






var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9hlns = parcelRequire("9hlns");


var $bTdbD = parcelRequire("bTdbD");


var $4NZXC = parcelRequire("4NZXC");


var $5izcQ = parcelRequire("5izcQ");


var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");


var $bedQP = parcelRequire("bedQP");


var $3qtLb = parcelRequire("3qtLb");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");

/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");




/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});


const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $eSUdr.default)`query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}`;
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $xQxzY.useQuery)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab).NO_SHOW_PAGECARD
    };
};


const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $2d41bbac85093ab1$export$f824d805fc04fcb2)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $42omo.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $42omo.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $42omo.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $42omo.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};



var $lfFzM = parcelRequire("lfFzM");





var $j3kZx = parcelRequire("j3kZx");





const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("hZJql"))).SpaceHoverPageCard
});



var $2vuKf = parcelRequire("2vuKf");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");










const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, isSpaceAdmin: isSpaceAdmin })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $42omo.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                isSpaceAdmin: isSpaceAdmin
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        isSpaceAdmin
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};


const $5a12275e9873d32f$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));

const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("lav2O"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("kUixh"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("loCxh"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $h82at.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading, relatedContent: relatedContent })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(// @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    spaceKey, isLicensed);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $42omo.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $42omo.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $42omo.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $42omo.useState)(0);
    const [spaceViewsError, setSpaceViewsError] = (0, $42omo.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $42omo.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $4d55e7bf74ef8f79$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey ?? ''
        }
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading;
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const isSpaceAdminOrSuperAdmin = isSpaceAdmin || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        isSpaceAdmin: isSpaceAdmin
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $f35e894e447c6262$export$3bba19b3f6dc31cd)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $42omo.useState)(false);
    const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $42omo.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $42omo.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3qtLb.PageTree), {
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        isSpaceAdminOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$RemovedSpotlightTarget, {
        name: "nav4-spotlight-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, (0, $6mKj3.expValEquals)('confluence_autonomous_space_curation', 'isEnabled', true) ? relatedContent : null, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d9810ba2fa073e42$export$d09f0ee316c3b5c1), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
};
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, $5a12275e9873d32f$var$SpaceViewsControllerComponent({
        ...props
    }));









const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("c2Apt"))).BlogTree
});












var $3d6VZ = parcelRequire("3d6VZ");


var $f7B1p = parcelRequire("f7B1p");

var $090b31fb8b21ef86$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    return Action;
}({});
var $090b31fb8b21ef86$export$f0c7a43b2eefe22f = /*#__PURE__*/ function(EXTERNAL_PRODUCT_CONNECTION) {
    EXTERNAL_PRODUCT_CONNECTION["LOOM"] = "loom";
    EXTERNAL_PRODUCT_CONNECTION["MICROSOFT_TEAMS"] = "teams";
    EXTERNAL_PRODUCT_CONNECTION["GOOGLE_DRIVE"] = "gdrive";
    return EXTERNAL_PRODUCT_CONNECTION;
}({});
const $090b31fb8b21ef86$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'figma.com',
        product: 'Figma',
        productKey: 'figma',
        iconUrl: 'https://static.figma.com/app/icon/1/favicon.ico'
    },
    {
        pattern: 'slack.com',
        product: 'Slack',
        productKey: 'slack',
        iconUrl: 'https://slack.com/favicon.ico'
    }
];
const $090b31fb8b21ef86$export$9911254b1f812303 = {
    productKey: 'link',
    iconUrl: ''
};


// name` values from `search.configuration.thirdPartyProducts
var $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME = /*#__PURE__*/ function(SEARCH_THIRD_PARTY_CONNECTOR_NAME) {
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["GOOGLE_DRIVE"] = "google-drive-connector";
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["MICROSOFT_TEAMS"] = "microsoft-teams-connector";
    return SEARCH_THIRD_PARTY_CONNECTOR_NAME;
}($06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME || {});
const $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION = 'SearchThirdPartyAuthConfiguration';
const $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY = `
query SearchThirdPartyAuthConfiguration($cloudId: ID!) {
	search {
		configuration(cloudId: $cloudId) {
			thirdPartyProducts {
				name
				isUserOAuthed
				providerId
			}
		}
	}
}
`.trim();
const $06f9e66a9eacf0bf$var$getLoomAuthStatus = async ()=>{
    try {
        const loomUserStatus = await (0, $3d6VZ.getAuthState)();
        return {
            isAuthenticated: loomUserStatus !== undefined && loomUserStatus !== 'NOT_FOUND'
        };
    } catch (e) {
        return {
            isAuthenticated: false,
            error: e instanceof Error ? e : new Error('Failed to fetch Loom auth status')
        };
    }
};
async function $06f9e66a9eacf0bf$var$fetchSearchThirdPartyProducts(cloudId) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY,
                variables: {
                    cloudId: cloudId
                },
                operationName: $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const products = json.data?.search?.configuration?.thirdPartyProducts ?? [];
        return {
            products: products
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch search third-party configuration')
        };
    }
}
function $06f9e66a9eacf0bf$var$authStatusForSearchConnector(products, connectorName, fetchError) {
    if (fetchError) return {
        isAuthenticated: false,
        error: fetchError
    };
    const matches = products.filter((p)=>p.name === connectorName);
    if (matches.length === 0) return {
        isAuthenticated: false
    };
    return {
        isAuthenticated: matches.some((p)=>p.isUserOAuthed)
    };
}
const $06f9e66a9eacf0bf$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const [authentications, setAuthentications] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const productsKey = products.join(',');
    const stableProductsRef = (0, $42omo.useRef)(products);
    if (stableProductsRef.current.join(',') !== productsKey) stableProductsRef.current = products;
    const refetch = (0, $42omo.useCallback)(async ()=>{
        const products_0 = stableProductsRef.current;
        if (products_0.length === 0) {
            setAuthentications({});
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const results = {};
            let searchProducts = [];
            let searchFetchError;
            if (products_0.includes((0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS) || products_0.includes((0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE)) {
                const searchResult = await $06f9e66a9eacf0bf$var$fetchSearchThirdPartyProducts(cloudId);
                if ('error' in searchResult) searchFetchError = searchResult.error;
                else searchProducts = searchResult.products;
            }
            for (const product of products_0)switch(product){
                case (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).LOOM:
                    results[(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).LOOM] = await $06f9e66a9eacf0bf$var$getLoomAuthStatus();
                    break;
                case (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS:
                    results[(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS] = $06f9e66a9eacf0bf$var$authStatusForSearchConnector(searchProducts, "microsoft-teams-connector", searchFetchError);
                    break;
                case (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE:
                    results[(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE] = $06f9e66a9eacf0bf$var$authStatusForSearchConnector(searchProducts, "google-drive-connector", searchFetchError);
                    break;
            }
            setAuthentications(results);
        } finally{
            setIsLoading(false);
        }
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        authentications: authentications,
        isLoading: isLoading,
        refetch: refetch
    };
};















var $T1bCI = parcelRequire("T1bCI");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $2W0qg = parcelRequire("2W0qg");


var $hmuev = parcelRequire("hmuev");


var $6xdDU = parcelRequire("6xdDU");





var $7xVCs = parcelRequire("7xVCs");


var $1I9Gw = parcelRequire("1I9Gw");





var $gMc0m = parcelRequire("gMc0m");





var $jTxSS = parcelRequire("jTxSS");










var $ccHMk = parcelRequire("ccHMk");


var $cO1el = parcelRequire("cO1el");


var $1Whri = parcelRequire("1Whri");


var $8tdj3 = parcelRequire("8tdj3");


var $auNCB = parcelRequire("auNCB");





var $eyWa4 = parcelRequire("eyWa4");







var $9ot3w = parcelRequire("9ot3w");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $5tmwS = parcelRequire("5tmwS");


var $eG1e2 = parcelRequire("eG1e2");


var $jdPfT = parcelRequire("jdPfT");





var $7aA9P = parcelRequire("7aA9P");


var $lsxnT = parcelRequire("lsxnT");


var $gqqjz = parcelRequire("gqqjz");











var $imt6g = parcelRequire("imt6g");


var $7yDmn = parcelRequire("7yDmn");







const $5ff49e7a1b080355$var$styles = {
    pressable: "_1rjcutpp _1e0c1txw _4cvr1h6o _1bah1h6o _bozgpxbi _y4tipxbi _bfhk1j28 _1o9zidpf _irr31j28",
    highlightRing: "_2rko1rr0 _1mou196n _195g196n _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _irr3plhp",
    iconWrapper: "_kqswh2mm _1bsb7vkz _4t3i7vkz _1o9zidpf",
    iconLayer: "_v56414mc _kqswstnw _154iidpf _1ltvidpf",
    iconLayerVisible: "_tzy4kb7n _t9ec1h7a",
    iconLayerHidden: "_tzy4idpf _t9ec18p1"
};
const $5ff49e7a1b080355$export$7eb83caae4372066 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { isSelected: isSelected, onClick: onClick, ariaLabel: ariaLabel } = t0;
    const t1 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerVisible : $5ff49e7a1b080355$var$styles.iconLayerHidden;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t2
        }, t3);
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerHidden : $5ff49e7a1b080355$var$styles.iconLayerVisible;
    let t6;
    if ($[5] !== t5) {
        t6 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t7);
        $[8] = t6;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t4 || $[11] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.highlightRing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.iconWrapper
        }, t4, t8));
        $[10] = t4;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== ariaLabel || $[14] !== onClick || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $5ff49e7a1b080355$var$styles.pressable,
            onClick: onClick,
            "aria-label": ariaLabel
        }, t9);
        $[13] = ariaLabel;
        $[14] = onClick;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
};





/**
 * @generated SignedSource<<e1461337ea6e9b3d7422c03a23ca2cf9>>
 * @relayHash afe0901b48e911b10f7b851c09b7931f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f
const $ffebeb9f14c82074$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afe0901b48e911b10f7b851c09b7931f",
            "id": "bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){content(ids:$ids){nodes{id,title}}}"
        }
    };
}();
$ffebeb9f14c82074$var$node.hash = "55f695ceabd6367765c49b523c7e2f29";
var $ffebeb9f14c82074$export$2e2bcd8739ae039 = $ffebeb9f14c82074$var$node;





const $d765c8713688ab6e$var$ContentTitlesQuery = (0, $ffebeb9f14c82074$export$2e2bcd8739ae039);
const $d765c8713688ab6e$export$7610585fadab893e = (contentIds)=>{
    const $ = (0, $frIzR.c)(14);
    let t0;
    if ($[0] !== contentIds) {
        t0 = new Set(contentIds);
        $[0] = contentIds;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = [
            ...t0
        ].filter(Boolean);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const unique = t1;
    const ids = unique;
    let t2;
    if ($[4] !== ids) {
        t2 = {
            ids: ids
        };
        $[4] = ids;
        $[5] = t2;
    } else t2 = $[5];
    const t3 = ids.length === 0;
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($d765c8713688ab6e$var$ContentTitlesQuery, t4);
    let map;
    if ($[9] !== data?.content?.nodes) {
        map = new Map();
        const nodes = data?.content?.nodes ?? [];
        for (const node of nodes)if (node?.id != null) map.set(node.id, node.title ?? "");
        $[9] = data?.content?.nodes;
        $[10] = map;
    } else map = $[10];
    const titlesByContentId = map;
    const isLoading = ids.length > 0 && loading;
    let t5;
    if ($[11] !== isLoading || $[12] !== titlesByContentId) {
        t5 = {
            titlesByContentId: titlesByContentId,
            isLoading: isLoading
        };
        $[11] = isLoading;
        $[12] = titlesByContentId;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};











const $3b31958c77e1b16d$var$i18n = (0, $h82at.defineMessages)({
    successFlagTitle: {
        id: "side-navigation.suggestion-actions.success.title",
        defaultMessage: "{count, plural, one {{count} item added to space} other {{count} items added to space}}"
    },
    successFlagDescription: {
        id: "side-navigation.suggestion-actions.success.description",
        defaultMessage: "Your selected content has been added to this space."
    },
    errorFlagTitle: {
        id: "side-navigation.suggestion-actions.error.title",
        defaultMessage: "Failed to add items to space"
    },
    errorFlagDescription: {
        id: "side-navigation.suggestion-actions.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $3b31958c77e1b16d$export$c9239e53ef385494 = ({ spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const submitActions = async (allSuggestions, selectedIds)=>{
        if (!spaceKey) return false;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $090b31fb8b21ef86$export$e19cd5f9376f8cee).ACCEPT : (0, $090b31fb8b21ef86$export$e19cd5f9376f8cee).REJECT
            }));
        try {
            await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    actions: actions
                })
            });
            flags?.showSuccessFlag({
                id: 'space-navigation.suggestion-actions.success',
                title: formatMessage($3b31958c77e1b16d$var$i18n.successFlagTitle, {
                    count: selectedIds.size
                }),
                description: formatMessage($3b31958c77e1b16d$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
            return true;
        } catch  {
            flags?.showErrorFlag({
                id: 'space-navigation.suggestion-actions.error',
                title: formatMessage($3b31958c77e1b16d$var$i18n.errorFlagTitle),
                description: formatMessage($3b31958c77e1b16d$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
            return false;
        }
    };
    return {
        submitActions: submitActions
    };
};

















const $c5ab38ff0f87742b$var$styles = {
    wrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    iconSlot: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqr5cr _kqswh2mm",
    iconSlotFirst: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqidpf _kqswh2mm"
};
const $c5ab38ff0f87742b$var$ICON_SIZE = {
    small: 16,
    large: 28
};
const $c5ab38ff0f87742b$var$TILT_ANGLE_DEG = 10;
const $c5ab38ff0f87742b$var$iconZIndex = (index, total)=>total - index;
function $c5ab38ff0f87742b$var$getTiltTransform(index) {
    const rotationDeg = index % 2 === 0 ? -$c5ab38ff0f87742b$var$TILT_ANGLE_DEG : $c5ab38ff0f87742b$var$TILT_ANGLE_DEG;
    return `rotate(${rotationDeg}deg)`;
}
const $c5ab38ff0f87742b$export$98526f0dffd4f41b = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { iconUrls: iconUrls, variant: t1, tilted: t2, testId: t3 } = t0;
    const variant = t1 === undefined ? "small" : t1;
    const tilted = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "stacked-content-type-icons" : t3;
    let T0;
    let t4;
    let t5;
    let t6;
    if ($[0] !== iconUrls || $[1] !== testId || $[2] !== tilted || $[3] !== variant) {
        const displayUrls = (iconUrls ?? []).slice(0, 3);
        T0 = (0, $gdv5Z.default);
        t4 = $c5ab38ff0f87742b$var$styles.wrapper;
        t5 = testId;
        t6 = displayUrls.length > 0 ? displayUrls.map((url, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: `${url}-${i}`,
                xcss: i === 0 ? $c5ab38ff0f87742b$var$styles.iconSlotFirst : $c5ab38ff0f87742b$var$styles.iconSlot,
                style: {
                    zIndex: $c5ab38ff0f87742b$var$iconZIndex(i, displayUrls.length),
                    transform: tilted && displayUrls.length > 1 ? $c5ab38ff0f87742b$var$getTiltTransform(i) : undefined
                },
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
                src: url,
                width: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                height: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                fallback: $c5ab38ff0f87742b$var$_temp,
                role: "presentation"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "currentColor"
        });
        $[0] = iconUrls;
        $[1] = testId;
        $[2] = tilted;
        $[3] = variant;
        $[4] = T0;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
    } else {
        T0 = $[4];
        t4 = $[5];
        t5 = $[6];
        t6 = $[7];
    }
    let t7;
    if ($[8] !== T0 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t4,
            testId: t5
        }, t6);
        $[8] = T0;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
};
function $c5ab38ff0f87742b$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
































const $cc28f14084497f84$var$i18n = (0, $h82at.defineMessages)({
    hoverCardFallbackDescription: {
        id: "side-navigation.review-content-suggestions-modal.hover-card-fallback-description",
        defaultMessage: "Open this item in a new tab to view it in {product}."
    },
    openHoverCardSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-hover-card-suggestion",
        defaultMessage: "Open item"
    },
    productGoogleDocs: {
        id: "side-navigation.review-content-suggestions-modal.product-google-docs.no-translate",
        defaultMessage: "Google Docs"
    },
    productGoogleSheets: {
        id: "side-navigation.review-content-suggestions-modal.product-google-sheets.no-translate",
        defaultMessage: "Google Sheets"
    },
    productGoogleSlides: {
        id: "side-navigation.review-content-suggestions-modal.product-google-slides.no-translate",
        defaultMessage: "Google Slides"
    },
    productGoogleDrive: {
        id: "side-navigation.review-content-suggestions-modal.product-google-drive.no-translate",
        defaultMessage: "Google Drive"
    },
    productLoom: {
        id: "side-navigation.review-content-suggestions-modal.product-loom.no-translate",
        defaultMessage: "Loom"
    },
    productFigma: {
        id: "side-navigation.review-content-suggestions-modal.product-figma.no-translate",
        defaultMessage: "Figma"
    },
    productSlack: {
        id: "side-navigation.review-content-suggestions-modal.product-slack.no-translate",
        defaultMessage: "Slack"
    },
    productLink: {
        id: "side-navigation.review-content-suggestions-modal.product-link",
        defaultMessage: "Link"
    },
    groupHoverCardItemCount: {
        id: "side-navigation.review-content-suggestions-modal.group-hover-card-item-count",
        defaultMessage: "{count, plural, one {# item} other {# items}}"
    }
});
function $cc28f14084497f84$export$2fbf412772ed0f39(url) {
    const productInfo = (0, $090b31fb8b21ef86$export$51b10001420b4ba3).find((entry)=>url.includes(entry.pattern));
    return productInfo ?? (0, $090b31fb8b21ef86$export$9911254b1f812303);
}
const $cc28f14084497f84$var$PRODUCT_LABEL_MESSAGES = {
    googleDocs: $cc28f14084497f84$var$i18n.productGoogleDocs,
    googleSheets: $cc28f14084497f84$var$i18n.productGoogleSheets,
    googleSlides: $cc28f14084497f84$var$i18n.productGoogleSlides,
    googleDrive: $cc28f14084497f84$var$i18n.productGoogleDrive,
    loom: $cc28f14084497f84$var$i18n.productLoom,
    figma: $cc28f14084497f84$var$i18n.productFigma,
    slack: $cc28f14084497f84$var$i18n.productSlack,
    link: $cc28f14084497f84$var$i18n.productLink
};
function $cc28f14084497f84$var$getProductLabelMessage(productKey) {
    return $cc28f14084497f84$var$PRODUCT_LABEL_MESSAGES[productKey];
}
const $cc28f14084497f84$var$styles = {
    hoverCard: "_2rko1mok _1yt4utpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbgx0z _bfhk1j9a _16qs130s",
    hoverCardContent: "_p12f1osq _1ul9idpf",
    hoverCardTitle: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _p12f1osq",
    hoverCardDescription: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _syazazsu _1yyjcs5v _p12f1osq",
    hoverCardFooter: "_195g1410 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1q51u2gc _syazazsu",
    hoverCardIcon: "_1bsbdlk8 _4t3idlk8 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    hoverCardOpenLink: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c116y _4cvr1h6o"
};
const $cc28f14084497f84$export$bf0a0c07cf58248c = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { suggestion: suggestion } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let iconUrl;
    let product;
    let t1;
    if ($[0] !== formatMessage || $[1] !== suggestion.description || $[2] !== suggestion.url) {
        const { productKey: productKey, iconUrl: t2 } = $cc28f14084497f84$export$2fbf412772ed0f39(suggestion.url);
        iconUrl = t2;
        product = formatMessage($cc28f14084497f84$var$getProductLabelMessage(productKey));
        t1 = suggestion.description?.trim() ? suggestion.description : formatMessage($cc28f14084497f84$var$i18n.hoverCardFallbackDescription, {
            product: product
        });
        $[0] = formatMessage;
        $[1] = suggestion.description;
        $[2] = suggestion.url;
        $[3] = iconUrl;
        $[4] = product;
        $[5] = t1;
    } else {
        iconUrl = $[3];
        product = $[4];
        t1 = $[5];
    }
    const description = t1;
    let t2;
    if ($[6] !== iconUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $cc28f14084497f84$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[6] = iconUrl;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== suggestion.title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025",
            xcss: $cc28f14084497f84$var$styles.hoverCardContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            weight: "medium",
            color: "color.text.accent.blue"
        }, suggestion.title)));
        $[8] = suggestion.title;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, t2, t3);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, description));
        $[13] = description;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== iconUrl) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $cc28f14084497f84$var$_temp2,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[15] = iconUrl;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== product) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, product);
        $[17] = product;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t6 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100",
            xcss: $cc28f14084497f84$var$styles.hoverCardFooter
        }, t6, t7);
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t4 || $[23] !== t5 || $[24] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            xcss: $cc28f14084497f84$var$styles.hoverCard,
            testId: "review-content-suggestion-hover-card"
        }, t4, t5, t8);
        $[22] = t4;
        $[23] = t5;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
};
const $cc28f14084497f84$export$89a7edf0c311b93 = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { title: title, itemCount: itemCount } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            weight: "medium",
            color: "color.text.accent.blue"
        }, title));
        $[1] = title;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== formatMessage || $[4] !== itemCount) {
        t3 = formatMessage($cc28f14084497f84$var$i18n.groupHoverCardItemCount, {
            count: itemCount
        });
        $[3] = formatMessage;
        $[4] = itemCount;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            xcss: $cc28f14084497f84$var$styles.hoverCard,
            testId: "review-content-suggestion-group-hover-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025",
            xcss: $cc28f14084497f84$var$styles.hoverCardContent
        }, t2, t4)));
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
function $cc28f14084497f84$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $cc28f14084497f84$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}


const $b84c4cb49dedd5e2$var$i18n = (0, $h82at.defineMessages)({
    bringTogetherTitle: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Add these suggestions and it\u2019ll be organized in this space."
    },
    addItemsToSpace: {
        id: "side-navigation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    expandGroup: {
        id: "side-navigation.review-content-suggestions-modal.expand-group",
        defaultMessage: "Expand {title}"
    },
    collapseGroup: {
        id: "side-navigation.review-content-suggestions-modal.collapse-group",
        defaultMessage: "Collapse {title}"
    },
    openSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title} in a new tab"
    },
    deselectGroup: {
        id: "side-navigation.review-content-suggestions-modal.deselect-group",
        defaultMessage: "Deselect group {title}"
    },
    selectGroup: {
        id: "side-navigation.review-content-suggestions-modal.select-group",
        defaultMessage: "Select group {title}"
    },
    deselectItem: {
        id: "side-navigation.review-content-suggestions-modal.deselect-item",
        defaultMessage: "Deselect {title}"
    },
    selectItem: {
        id: "side-navigation.review-content-suggestions-modal.select-item",
        defaultMessage: "Select {title}"
    },
    untitled: {
        id: "side-navigation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    loading: {
        id: "side-navigation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading suggestions\u2026"
    },
    submitting: {
        id: "side-navigation.review-content-suggestions-modal.submitting",
        defaultMessage: "Adding items to space\u2026"
    },
    spaceAvatarAlt: {
        id: "side-navigation.review-content-suggestions-modal.space-avatar-alt",
        defaultMessage: "Avatar for {spaceName}"
    }
});
const $b84c4cb49dedd5e2$var$styles = {
    layout: "_2rkopb1k _4t3i10fc",
    leftPanel: "_zulp1ejb _1rjc1jfw _18zrpxbi _16jlkb7n _i0dl1ssb _1e0c1txw _2lx21bp4 _18m91wug",
    rightPanel: "_1reo15vq _18m915vq _16jlkb7n _i0dl1ssb _kqswh2mm _bfhk1ymo _5fbcpb1k _1einpb1k",
    previewPanelContent: "_85i5pxbi",
    previewCard: "_1yt4utpp _bfhk1j9a",
    previewGroupsSection: "_zulpu2gc _2rko1qi0 _1yt41b66 _189edkaa _1dqonqa1 _1h6d1ymo _1e0c1txw _2lx21bp4 _16qssmn1",
    previewFoldersList: "_zulpu2gc _1e0c1txw _2lx21bp4",
    previewFolderPreview: "_19itglyw _bfhk1j9a",
    previewFolderHeader: "_zulpu2gc _2rko12b0 _v564mvc0 _18zrutpp _1rjc12x7 _1e0c1txw _4cvr1h6o _1bah1yb4 _kqswh2mm _irr3i8nm",
    previewFolderTitleRow: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1ul9idpf",
    previewGroupTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf",
    previewFolderBody: "_18zrutpp _1e0cglyw _85i5utpp",
    previewFolderBodyExpanded: "_1e0c1ule",
    previewFolderBodyIndented: "_bozgze3t",
    previewSuggestionList: "_zulp12x7 _1e0c1txw _2lx21bp4 _1bsb1osq",
    previewSuggestionRow: "_zulpu2gc _1rjc1b66 _1e0c1txw _4cvr1h6o _1ul9idpf _1bsb1osq _bozgxy5q _y4ti12x7",
    previewSuggestionTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf",
    spaceHeader: "_zulpu2gc _1rjcv47k _18zr1ejb _bfhk1j9a _1doce4h9 _1il9nqa1 _1o3i1l7x _1s1gpb1k _4cvr1h6o _1o9zidpf",
    spaceAvatarWrapper: "_2rko1qi0 _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _1o9zidpf",
    stackedContentTypeIconWrapper: "_6rthv47k",
    closeButtonWrapper: "_154iu2gc _1ltvu2gc",
    eyelashWrapper: "_kqswh2mm",
    eyelash: "_y44vjpww _1reoewfl _18m9ewfl _kqswstnw _154i1m4h _1ltv1m4h _1pbyb4wl _lcxvglyw",
    groupListScrollArea: "_16jlkb7n _18m91wug _1fjgglyw _1tkeidpf",
    container: "_2rkopb1k _1reoewfl _18m9ewfl _kqswstnw _154i1epz _1ltvxncg _1xi2ze3t _94n5ze3t _bfhkvuon",
    groupCard: "_2rkopb1k _1reo15vq _18m915vq _v5641po6 _189ee4h9 _1dqonqa1 _1h6d1l7x _4cvx1ihb",
    groupCardExpanded: "_1reoewfl _18m9ewfl _1h6d1ihb _kqswh2mm _1pbyidpf",
    groupCardHovering: "_1h6d1l7x _kqswh2mm _1pby1fw0",
    expandButton: "_zulpu2gc _1rjcutpp _1e0c1txw _4cvr1h6o _1bah1y6m _y3gnv2br _16jlkb7n _bozg1b66 _y4tiutpp _bfhk1j28 _irr31j28",
    groupTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    itemsListOuter: "_v5641i4b _1e0c11p5 _2z0563bf _tzy4idpf",
    itemsListOuterExpanded: "_2z05hkll _tzy4kb7n",
    itemsList: "_1reoewfl _18m9ewfl _1tkeidpf",
    itemRowContainer: "_2rko12b0 _v564mvc0 _kqswh2mm _1pbyidpf _1bsb1osq _irr3i8nm",
    itemRowContainerHovered: "_1pbykb7n",
    portalHoverCard: "_v564sfsx _kqsw1n9t _1pby9y44 _lcxvglyw _tzy4idpf _t9ec155f",
    portalHoverCardVisible: "_tzy4kb7n _lcxv1wug _t9ec1kli",
    previewPlaceholderSection: "_18zr1b66 _1rjcu2gc _1e0c1txw _2lx21bp4",
    previewPlaceholderRow: "_1rjcu2gc _1e0c1txw _4cvr1h6o",
    previewPlaceholderDot: "_2rko12b0 _1bsb19bv _4t3i19bv _bfhki8nm _1o9zidpf",
    previewPlaceholderBarLong: "_2rko12b0 _4t3iftgi _1bsb1n8h _bfhki8nm",
    previewPlaceholderBarFull: "_2rko12b0 _4t3iftgi _1bsb1mxx _bfhki8nm",
    suggestionLinkWrapper: "_16jlkb7n _1ul9idpf",
    suggestionLink: "_zulpu2gc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjc12x7 _1e0c1txw _4cvr1h6o _1n261q9c _1ul9idpf _bozg1b66 _y4tiutpp _syazi7uo _9oik1r31 _1bnxglyw _jf4cnqa1",
    suggestionIconSlot: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    suggestionTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    suggestionLinkExternalIcon: "_1o9zidpf",
    addButtonRow: "_85i5pxbi",
    itemRow: "_1rjcu2gc _uwhke4h9 _15a5nqa1 _1i531l7x _irr3i8nm",
    unselectedOpacity: "_tzy42wxo",
    loadingOverlay: "_1e0c1txw _4cvr1h6o _1bah1h6o _1tke10fc"
};
// Estimated max height of the hover cards (in px) used for flip-up logic
const $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT = 160;
const $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET = 8;
const $b84c4cb49dedd5e2$var$useHoverCardPortal = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const flipUp = t0 === undefined ? false : t0;
    const ref = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [position, setPosition] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== flipUp) {
        t1 = ()=>{
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const spaceBelow = window.innerHeight - rect.bottom;
                const top = !flipUp && spaceBelow > $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT ? rect.bottom + $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET : rect.top - $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT - $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET;
                setPosition({
                    top: top,
                    left: rect.left
                });
            }
            setIsVisible(true);
        };
        $[0] = flipUp;
        $[1] = t1;
    } else t1 = $[1];
    const show = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsVisible(false);
        $[2] = t2;
    } else t2 = $[2];
    const hide = t2;
    let t3;
    if ($[3] !== isVisible || $[4] !== position || $[5] !== show) {
        t3 = {
            ref: ref,
            isVisible: isVisible,
            position: position,
            show: show,
            hide: hide
        };
        $[3] = isVisible;
        $[4] = position;
        $[5] = show;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
const $b84c4cb49dedd5e2$var$SuggestionItemRow = (t0)=>{
    const $ = (0, $frIzR.c)(52);
    const { suggestion: suggestion, isSelected: isSelected, onToggleSelectItem: onToggleSelectItem, onHoverCardVisibilityChange: onHoverCardVisibilityChange } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== suggestion.url) {
        t1 = (0, $cc28f14084497f84$export$2fbf412772ed0f39)(suggestion.url);
        $[0] = suggestion.url;
        $[1] = t1;
    } else t1 = $[1];
    const { iconUrl: iconUrl } = t1;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    let t2;
    if ($[2] !== onHoverCardVisibilityChange || $[3] !== show) {
        t2 = ()=>{
            show();
            onHoverCardVisibilityChange(true);
        };
        $[2] = onHoverCardVisibilityChange;
        $[3] = show;
        $[4] = t2;
    } else t2 = $[4];
    const handleShow = t2;
    let t3;
    if ($[5] !== hide || $[6] !== onHoverCardVisibilityChange) {
        t3 = ()=>{
            hide();
            onHoverCardVisibilityChange(false);
        };
        $[5] = hide;
        $[6] = onHoverCardVisibilityChange;
        $[7] = t3;
    } else t3 = $[7];
    const handleHide = t3;
    const t4 = isVisible && $b84c4cb49dedd5e2$var$styles.itemRowContainerHovered;
    let t5;
    if ($[8] !== t4) {
        t5 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRowContainer, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = `review-content-suggestion-row-${suggestion.id}`;
    const t7 = !isSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t8;
    if ($[10] !== t7) {
        t8 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRow, t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== onToggleSelectItem || $[13] !== suggestion.id) {
        t9 = ()=>onToggleSelectItem(suggestion.id);
        $[12] = onToggleSelectItem;
        $[13] = suggestion.id;
        $[14] = t9;
    } else t9 = $[14];
    const t10 = isSelected ? $b84c4cb49dedd5e2$var$i18n.deselectItem : $b84c4cb49dedd5e2$var$i18n.selectItem;
    let t11;
    if ($[15] !== formatMessage || $[16] !== suggestion.title || $[17] !== t10) {
        t11 = formatMessage(t10, {
            title: suggestion.title
        });
        $[15] = formatMessage;
        $[16] = suggestion.title;
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== isSelected || $[20] !== t11 || $[21] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isSelected,
            onClick: t9,
            ariaLabel: t11
        });
        $[19] = isSelected;
        $[20] = t11;
        $[21] = t9;
        $[22] = t12;
    } else t12 = $[22];
    const t13 = suggestion.url;
    let t14;
    if ($[23] !== formatMessage || $[24] !== suggestion.title) {
        t14 = formatMessage($b84c4cb49dedd5e2$var$i18n.openSuggestion, {
            title: suggestion.title
        });
        $[23] = formatMessage;
        $[24] = suggestion.title;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== iconUrl) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[26] = iconUrl;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== suggestion.title) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 1
        }, suggestion.title));
        $[28] = suggestion.title;
        $[29] = t16;
    } else t16 = $[29];
    let t17;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkExternalIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[30] = t17;
    } else t17 = $[30];
    let t18;
    if ($[31] !== suggestion.url || $[32] !== t14 || $[33] !== t15 || $[34] !== t16) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: t13,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": t14,
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLink
        }, t15, t16, t17));
        $[31] = suggestion.url;
        $[32] = t14;
        $[33] = t15;
        $[34] = t16;
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== t12 || $[37] !== t18 || $[38] !== t8) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: t8
        }, t12, t18);
        $[36] = t12;
        $[37] = t18;
        $[38] = t8;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== isVisible || $[41] !== position || $[42] !== suggestion) {
        t20 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            },
            testId: "review-content-suggestion-hover-card-portal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$bf0a0c07cf58248c), {
            suggestion: suggestion
        })), document.body);
        $[40] = isVisible;
        $[41] = position;
        $[42] = suggestion;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] !== handleHide || $[45] !== handleShow || $[46] !== ref || $[47] !== t19 || $[48] !== t20 || $[49] !== t5 || $[50] !== t6) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: t5,
            onMouseEnter: handleShow,
            onMouseLeave: handleHide,
            onFocusCapture: handleShow,
            onBlur: handleHide,
            testId: t6
        }, t19, t20);
        $[44] = handleHide;
        $[45] = handleShow;
        $[46] = ref;
        $[47] = t19;
        $[48] = t20;
        $[49] = t5;
        $[50] = t6;
        $[51] = t21;
    } else t21 = $[51];
    return t21;
};
const $b84c4cb49dedd5e2$var$SuggestionGroupRow = (t0)=>{
    const $ = (0, $frIzR.c)(73);
    const { parentTitle: parentTitle, suggestions: suggestions, isExpanded: isExpanded, isGroupSelected: isGroupSelected, selectedItems: selectedItems, toggleExpand: toggleExpand, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem, onGroupHoverChange: onGroupHoverChange } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [isHoverCardVisible, setIsHoverCardVisible] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== selectedItems || $[1] !== suggestions) {
        let t2;
        if ($[3] !== selectedItems) {
            t2 = (suggestion)=>selectedItems.has(suggestion.id);
            $[3] = selectedItems;
            $[4] = t2;
        } else t2 = $[4];
        t1 = suggestions.filter(t2);
        $[0] = selectedItems;
        $[1] = suggestions;
        $[2] = t1;
    } else t1 = $[2];
    const selectedSuggestionCount = t1.length;
    const t2 = isExpanded && $b84c4cb49dedd5e2$var$styles.groupCardExpanded;
    const t3 = isHoverCardVisible && $b84c4cb49dedd5e2$var$styles.groupCardHovering;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.groupCard, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[8] !== onGroupHoverChange || $[9] !== parentId) {
        t5 = ()=>onGroupHoverChange(parentId, true);
        t6 = ()=>onGroupHoverChange(parentId, false);
        t7 = ()=>onGroupHoverChange(parentId, true);
        t8 = (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) onGroupHoverChange(parentId, false);
        };
        $[8] = onGroupHoverChange;
        $[9] = parentId;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else {
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
        t8 = $[13];
    }
    const t9 = `review-content-suggestion-group-card-${parentId}`;
    const t10 = !isGroupSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t11;
    if ($[14] !== suggestions || $[15] !== toggleSelectGroup) {
        t11 = ()=>toggleSelectGroup(suggestions);
        $[14] = suggestions;
        $[15] = toggleSelectGroup;
        $[16] = t11;
    } else t11 = $[16];
    const t12 = isGroupSelected ? $b84c4cb49dedd5e2$var$i18n.deselectGroup : $b84c4cb49dedd5e2$var$i18n.selectGroup;
    let t13;
    if ($[17] !== formatMessage || $[18] !== parentTitle || $[19] !== t12) {
        t13 = formatMessage(t12, {
            title: parentTitle
        });
        $[17] = formatMessage;
        $[18] = parentTitle;
        $[19] = t12;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== isGroupSelected || $[22] !== t11 || $[23] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isGroupSelected,
            onClick: t11,
            ariaLabel: t13
        });
        $[21] = isGroupSelected;
        $[22] = t11;
        $[23] = t13;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== parentId || $[26] !== toggleExpand) {
        t15 = ()=>toggleExpand(parentId);
        $[25] = parentId;
        $[26] = toggleExpand;
        $[27] = t15;
    } else t15 = $[27];
    const t16 = isExpanded ? $b84c4cb49dedd5e2$var$i18n.collapseGroup : $b84c4cb49dedd5e2$var$i18n.expandGroup;
    let t17;
    if ($[28] !== formatMessage || $[29] !== parentTitle || $[30] !== t16) {
        t17 = formatMessage(t16, {
            title: parentTitle
        });
        $[28] = formatMessage;
        $[29] = parentTitle;
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== parentTitle) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1
        }, parentTitle));
        $[32] = parentTitle;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== selectedSuggestionCount) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, selectedSuggestionCount);
        $[34] = selectedSuggestionCount;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== isExpanded) {
        t20 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[36] = isExpanded;
        $[37] = t20;
    } else t20 = $[37];
    let t21;
    if ($[38] !== isExpanded || $[39] !== t15 || $[40] !== t17 || $[41] !== t18 || $[42] !== t19 || $[43] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.expandButton,
            onClick: t15,
            "aria-expanded": isExpanded,
            "aria-label": t17
        }, t18, t19, t20);
        $[38] = isExpanded;
        $[39] = t15;
        $[40] = t17;
        $[41] = t18;
        $[42] = t19;
        $[43] = t20;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== t10 || $[46] !== t14 || $[47] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: t10
        }, t14, t21);
        $[45] = t10;
        $[46] = t14;
        $[47] = t21;
        $[48] = t22;
    } else t22 = $[48];
    const t23 = isExpanded && $b84c4cb49dedd5e2$var$styles.itemsListOuterExpanded;
    let t24;
    if ($[49] !== t23) {
        t24 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemsListOuter, t23);
        $[49] = t23;
        $[50] = t24;
    } else t24 = $[50];
    const t25 = !isExpanded;
    let t26;
    if ($[51] !== onToggleSelectItem || $[52] !== selectedItems || $[53] !== suggestions) {
        let t27;
        if ($[55] !== onToggleSelectItem || $[56] !== selectedItems) {
            t27 = (suggestion_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionItemRow, {
                    key: suggestion_0.id,
                    suggestion: suggestion_0,
                    isSelected: selectedItems.has(suggestion_0.id),
                    onToggleSelectItem: onToggleSelectItem,
                    onHoverCardVisibilityChange: setIsHoverCardVisible
                });
            $[55] = onToggleSelectItem;
            $[56] = selectedItems;
            $[57] = t27;
        } else t27 = $[57];
        t26 = suggestions.map(t27);
        $[51] = onToggleSelectItem;
        $[52] = selectedItems;
        $[53] = suggestions;
        $[54] = t26;
    } else t26 = $[54];
    let t27;
    if ($[58] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.itemsList
        }, t26);
        $[58] = t26;
        $[59] = t27;
    } else t27 = $[59];
    let t28;
    if ($[60] !== t24 || $[61] !== t25 || $[62] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t24,
            "aria-hidden": t25
        }, t27);
        $[60] = t24;
        $[61] = t25;
        $[62] = t27;
        $[63] = t28;
    } else t28 = $[63];
    let t29;
    if ($[64] !== t22 || $[65] !== t28 || $[66] !== t4 || $[67] !== t5 || $[68] !== t6 || $[69] !== t7 || $[70] !== t8 || $[71] !== t9) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t4,
            onMouseEnter: t5,
            onMouseLeave: t6,
            onFocusCapture: t7,
            onBlur: t8,
            testId: t9
        }, t22, t28);
        $[64] = t22;
        $[65] = t28;
        $[66] = t4;
        $[67] = t5;
        $[68] = t6;
        $[69] = t7;
        $[70] = t8;
        $[71] = t9;
        $[72] = t29;
    } else t29 = $[72];
    return t29;
};
const $b84c4cb49dedd5e2$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, expandedGroups: expandedGroups, toggleExpand: toggleExpand, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem, onGroupHoverChange: onGroupHoverChange } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== expandedGroups || $[1] !== formatMessage || $[2] !== groupedSuggestionsWithTitles || $[3] !== onGroupHoverChange || $[4] !== selectedItems || $[5] !== toggleExpand || $[6] !== toggleSelectGroup || $[7] !== toggleSelectItem) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].map((t2)=>{
            const [parentId, t3] = t2;
            const { parentTitle: parentTitle, suggestions: groupSuggestions } = t3;
            const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionGroupRow, {
                key: parentId,
                parentTitle: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                suggestions: groupSuggestions,
                isExpanded: expandedGroups.has(parentId),
                isGroupSelected: isGroupSelected,
                selectedItems: selectedItems,
                toggleExpand: toggleExpand,
                parentId: parentId,
                toggleSelectGroup: toggleSelectGroup,
                onToggleSelectItem: toggleSelectItem,
                onGroupHoverChange: onGroupHoverChange
            });
        }));
        $[0] = expandedGroups;
        $[1] = formatMessage;
        $[2] = groupedSuggestionsWithTitles;
        $[3] = onGroupHoverChange;
        $[4] = selectedItems;
        $[5] = toggleExpand;
        $[6] = toggleSelectGroup;
        $[7] = toggleSelectItem;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
};
const $b84c4cb49dedd5e2$var$PreviewFolderHeader = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { title: title, itemCount: itemCount, isFolderExpanded: isFolderExpanded } = t0;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    let t1;
    if ($[0] !== isFolderExpanded) {
        t1 = isFolderExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        });
        $[0] = isFolderExpanded;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewGroupTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1
        }, title));
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewFolderTitleRow
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== isVisible || $[8] !== itemCount || $[9] !== position || $[10] !== title) {
        t4 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$89a7edf0c311b93), {
            title: title,
            itemCount: itemCount
        })), document.body);
        $[7] = isVisible;
        $[8] = itemCount;
        $[9] = position;
        $[10] = title;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== hide || $[13] !== ref || $[14] !== show || $[15] !== t3 || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: $b84c4cb49dedd5e2$var$styles.previewFolderHeader,
            onMouseEnter: show,
            onMouseLeave: hide
        }, t3, t4);
        $[12] = hide;
        $[13] = ref;
        $[14] = show;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
const $b84c4cb49dedd5e2$var$PreviewSuggestionRow = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { suggestion: suggestion, iconUrl: iconUrl } = t0;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    const t1 = isVisible && $b84c4cb49dedd5e2$var$styles.itemRowContainerHovered;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRowContainer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== iconUrl) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp2,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[2] = iconUrl;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== suggestion.title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 1
        }, suggestion.title));
        $[4] = suggestion.title;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionRow
        }, t3, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== isVisible || $[10] !== position || $[11] !== suggestion) {
        t6 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$bf0a0c07cf58248c), {
            suggestion: suggestion
        })), document.body);
        $[9] = isVisible;
        $[10] = position;
        $[11] = suggestion;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== hide || $[14] !== ref || $[15] !== show || $[16] !== t2 || $[17] !== t5 || $[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: t2,
            onMouseEnter: show,
            onMouseLeave: hide,
            onFocusCapture: show,
            onBlur: hide
        }, t5, t6);
        $[13] = hide;
        $[14] = ref;
        $[15] = show;
        $[16] = t2;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
const $b84c4cb49dedd5e2$var$ModalRightPanel = (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, previewParentId: previewParentId, isHoveringGroupList: isHoveringGroupList, hoveredParentId: hoveredParentId, spaceName: spaceName, iconPath: iconPath } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.closeButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }));
        $[0] = t1;
    } else t1 = $[0];
    const t2 = iconPath || "";
    let t3;
    if ($[1] !== formatMessage || $[2] !== spaceName) {
        t3 = formatMessage($b84c4cb49dedd5e2$var$i18n.spaceAvatarAlt, {
            spaceName: spaceName || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled)
        });
        $[1] = formatMessage;
        $[2] = spaceName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage || $[5] !== spaceName) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: formatMessage($b84c4cb49dedd5e2$var$i18n.spaceAvatarAlt, {
                    spaceName: spaceName || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled)
                })
            });
        $[4] = formatMessage;
        $[5] = spaceName;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceAvatarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: t2,
            width: "24",
            height: "24",
            alt: t3,
            fallback: t4
        }));
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage || $[12] !== spaceName) {
        t6 = spaceName || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled);
        $[11] = formatMessage;
        $[12] = spaceName;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceHeaderTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t6));
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t5 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceHeader
        }, t5, t7);
        $[16] = t5;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderSection,
            testId: "review-content-suggestions-modal-preview-placeholder-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        }));
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== hoveredParentId || $[21] !== isHoveringGroupList || $[22] !== previewParentId) {
        t10 = isHoveringGroupList && hoveredParentId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            key: `eyelash-${previewParentId}`,
            xmlns: "http://www.w3.org/2000/svg",
            width: "68",
            height: "72",
            viewBox: "0 0 79 84",
            fill: "none",
            "data-testid": "review-content-suggestions-modal-eyelash",
            className: (0, $gMc0m.default)([
                $b84c4cb49dedd5e2$var$styles.eyelash
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M46.8305 18.5258C47.1098 17.9661 43.6268 8.90741 42.7488 11.521C42.2936 12.4058 42.5248 13.2117 43.5174 13.4554C41.7549 13.774 44.5278 15.4349 44.1037 16.2809C42.7767 16.0236 45.925 18.4365 44.5093 17.9953C45.1375 27.8747 61.4539 47.3269 49.1561 23.3778C49.0744 25.796 48.1128 23.545 48.1739 22.458C50.1084 23.9562 47.7869 19.4885 47.0583 18.6728C47.3738 20.0681 45.7105 17.7992 46.8271 18.5301L46.8305 18.5258Z",
            fill: "#101214"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M35.0784 36.7323C34.7386 35.4516 24.741 30.304 23.7564 29.6503C21.4451 28.5916 21.8766 31.5473 23.7521 31.9823C24.1049 32.2151 26.8063 32.9863 25.8424 33.6122C26.9098 36.11 31.5063 36.3441 32.2162 38.4572C32.7437 38.1031 33.6064 38.8355 33.9705 38.6541C34.0289 39.2864 34.9612 39.616 35.0079 39.4628C37.7835 42.0995 39.7426 38.6927 36.245 37.3269C36.3602 37.2145 35.6467 36.4956 35.0869 36.7321L35.0784 36.7323Z",
            fill: "#101214"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M24.963 69.8221C26.6738 70.9367 25.0975 70.8963 24.267 70.3448C25.383 69.2761 22.2883 69.3545 21.5652 69.7215C21.8995 69.7773 22.0611 70.3228 21.3734 70.2454C21.7268 68.9194 13.0408 68.0384 17.3812 71.1509C17.5287 71.156 17.4988 70.0879 17.7021 70.4339C17.5556 72.0383 18.8157 71.0002 19.1881 70.9031C19.2546 71.7465 19.5499 70.9879 19.6776 71.344C19.3094 72.4465 21.3534 70.7021 20.9218 71.7891C23.0595 73.6544 26.7834 71.6524 28.4396 73.3301C29.3174 71.5064 35.9199 74.7917 33.1474 70.8491C31.6157 70.1918 24.1523 68.5651 24.963 69.8221Z",
            fill: "#101214"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M6.74898 49.2677C6.29473 51.8253 12.2062 51.6791 13.9219 52.8612C16.019 54.5247 37.5618 61.2955 31.6306 55.7815C25.1019 53.783 19.9198 51.0908 11.8547 49.5917C10.5468 49.258 6.41403 47.4335 6.74898 49.2677Z",
            fill: "#101214"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M68.2125 30.6354C70.56 32.2805 68.0111 34.2349 69.9592 35.7792C73.6428 38.1546 73.0128 18.9394 69.4953 19.3145C66.5877 20.0435 69.3925 29.3498 68.2125 30.6354Z",
            fill: "#101214"
        })) : null;
        $[20] = hoveredParentId;
        $[21] = isHoveringGroupList;
        $[22] = previewParentId;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== formatMessage || $[25] !== groupedSuggestionsWithTitles || $[26] !== previewParentId || $[27] !== selectedItems) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewGroupsSection,
            testId: "review-content-suggestions-modal-preview-groups-section"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].filter((t12)=>{
            const [, t13] = t12;
            const { suggestions: groupSuggestions } = t13;
            return groupSuggestions.some((s)=>selectedItems.has(s.id));
        }).map((t14)=>{
            const [parentId, t15] = t14;
            const { parentTitle: parentTitle, suggestions: groupSuggestions_0 } = t15;
            const isFolderExpanded = previewParentId === parentId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: parentId,
                xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.previewFolderPreview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$PreviewFolderHeader, {
                title: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                itemCount: groupSuggestions_0.length,
                isFolderExpanded: isFolderExpanded
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.previewFolderBody, $b84c4cb49dedd5e2$var$styles.previewFolderBodyIndented, isFolderExpanded && $b84c4cb49dedd5e2$var$styles.previewFolderBodyExpanded)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.050",
                xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionList
            }, groupSuggestions_0.filter((s_0)=>selectedItems.has(s_0.id)).map($b84c4cb49dedd5e2$var$_temp3))));
        }));
        $[24] = formatMessage;
        $[25] = groupedSuggestionsWithTitles;
        $[26] = previewParentId;
        $[27] = selectedItems;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== t10 || $[30] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.eyelashWrapper
        }, t10, t11);
        $[29] = t10;
        $[30] = t11;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderSection,
            testId: "review-content-suggestions-modal-preview-placeholder-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        }));
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t12) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPanelContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewCard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100",
            xcss: $b84c4cb49dedd5e2$var$styles.previewFoldersList
        }, t9, t12, t13)));
        $[33] = t12;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== t14 || $[36] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.rightPanel
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.container
        }, t8, t14));
        $[35] = t14;
        $[36] = t8;
        $[37] = t15;
    } else t15 = $[37];
    return t15;
};
const $b84c4cb49dedd5e2$export$8a4b505874e89d07 = ({ groups: groups, iconUrls: iconUrls, spaceKey: spaceKey, spaceName: spaceName, iconPath: iconPath, onClose: onClose, onSaveSuccess: onSaveSuccess, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const allSuggestions = (0, $42omo.useMemo)(()=>groups.flatMap((g)=>g.remoteObjects), [
        groups
    ]);
    const [expandedGroups, setExpandedGroups] = (0, $42omo.useState)(()=>new Set());
    const [selectedItems, setSelectedItems] = (0, $42omo.useState)(()=>new Set(allSuggestions.map((s)=>s.id)));
    const [isHoveringGroupList, setIsHoveringGroupList] = (0, $42omo.useState)(false);
    const [hoveredParentId, setHoveredParentId] = (0, $42omo.useState)(null);
    const [previewParentId, setPreviewParentId] = (0, $42omo.useState)(groups[0]?.parentId);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const parentIds = (0, $42omo.useMemo)(()=>groups.map((g_0)=>String(g_0.parentId)), [
        groups
    ]);
    const { titlesByContentId: titlesByContentId, isLoading: isLoadingTitles } = (0, $d765c8713688ab6e$export$7610585fadab893e)(parentIds);
    const { submitActions: submitActions } = (0, $3b31958c77e1b16d$export$c9239e53ef385494)({
        spaceKey: spaceKey,
        flags: flags
    });
    const isLoading = isLoadingTitles || isSubmitting;
    const handleAdd = async ()=>{
        setIsSubmitting(true);
        try {
            const ok = await submitActions(allSuggestions, selectedItems);
            if (ok) await onSaveSuccess();
        } finally{
            setIsSubmitting(false);
        }
    };
    const groupedSuggestionsWithTitles = (0, $42omo.useMemo)(()=>{
        const result = new Map();
        groups.forEach((group)=>{
            result.set(group.parentId, {
                parentTitle: titlesByContentId.get(String(group.parentId)) ?? '',
                suggestions: group.remoteObjects
            });
        });
        return result;
    }, [
        groups,
        titlesByContentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (previewParentId === undefined || groups.length === 0) {
            setPreviewParentId(groups[0]?.parentId);
            return;
        }
        if (!groups.some((group_0)=>group_0.parentId === previewParentId)) setPreviewParentId(groups[0]?.parentId);
    }, [
        groups,
        previewParentId
    ]);
    const handleGroupHoverChange = (parentId, isHovering)=>{
        setIsHoveringGroupList(isHovering);
        setHoveredParentId(isHovering ? parentId : null);
        if (isHovering) setPreviewParentId(parentId);
    };
    const toggleExpand = (parentId_0)=>{
        setExpandedGroups((prev)=>{
            const next = new Set(prev);
            if (next.has(parentId_0)) next.delete(parentId_0);
            else next.add(parentId_0);
            return next;
        });
    };
    const toggleSelectItem = (itemId)=>{
        setSelectedItems((prev_0)=>{
            const next_0 = new Set(prev_0);
            if (next_0.has(itemId)) next_0.delete(itemId);
            else next_0.add(itemId);
            return next_0;
        });
    };
    const toggleSelectGroup = (groupSuggestions)=>{
        const allSelected = groupSuggestions.every((s_0)=>selectedItems.has(s_0.id));
        setSelectedItems((prev_1)=>{
            const next_1 = new Set(prev_1);
            groupSuggestions.forEach((s_1)=>{
                if (allSelected) next_1.delete(s_1.id);
                else next_1.add(s_1.id);
            });
            return next_1;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        width: "90vw"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.loadingOverlay,
        testId: "review-content-suggestions-modal-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        label: isSubmitting ? formatMessage($b84c4cb49dedd5e2$var$i18n.submitting) : formatMessage($b84c4cb49dedd5e2$var$i18n.loading)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.leftPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.stackedContentTypeIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
        iconUrls: iconUrls,
        variant: "large",
        tilted: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.groupListScrollArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalLeftPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        selectedItems: selectedItems,
        expandedGroups: expandedGroups,
        toggleExpand: toggleExpand,
        toggleSelectGroup: toggleSelectGroup,
        toggleSelectItem: toggleSelectItem,
        onGroupHoverChange: handleGroupHoverChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "end",
        xcss: $b84c4cb49dedd5e2$var$styles.addButtonRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>void handleAdd(),
        isDisabled: selectedItems.size === 0
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.addItemsToSpace, {
        count: selectedItems.size
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalRightPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        selectedItems: selectedItems,
        previewParentId: previewParentId,
        isHoveringGroupList: isHoveringGroupList,
        hoveredParentId: hoveredParentId,
        spaceName: spaceName,
        iconPath: iconPath
    })));
};
const $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$export$8a4b505874e89d07, {
                ...props,
                flags: flags
            }));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
function $b84c4cb49dedd5e2$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp3(suggestion) {
    const { iconUrl: iconUrl } = (0, $cc28f14084497f84$export$2fbf412772ed0f39)(suggestion.url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$PreviewSuggestionRow, {
        key: suggestion.id,
        suggestion: suggestion,
        iconUrl: iconUrl
    });
}








const $d3bfb9815ee47511$export$b1532bcf7c9b2548 = (spaceKey)=>{
    const [groups, setGroups] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        if (!spaceKey) {
            setGroups([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`, {
                method: 'GET'
            });
            const data = await response.json();
            setGroups(data.suggestions ?? []);
        } catch  {
        // Silently fail — card won't render if there are no suggestions
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        groups: groups,
        isLoading: isLoading,
        refetch: refetch
    };
};




const $e69b9564388a8a7c$var$PRODUCT_LABELS = {
    googleDocs: 'Google Docs',
    googleSheets: 'Google Sheets',
    googleSlides: 'Google Slides',
    googleDrive: 'Google Drive',
    loom: 'Loom',
    figma: 'Figma',
    slack: 'Slack',
    link: 'Link'
};
function $e69b9564388a8a7c$export$451fcc3902224a39(url) {
    const productInfo = (0, $090b31fb8b21ef86$export$51b10001420b4ba3).find((entry)=>url.includes(entry.pattern)) ?? (0, $090b31fb8b21ef86$export$9911254b1f812303);
    return {
        product: $e69b9564388a8a7c$var$PRODUCT_LABELS[productInfo.productKey],
        iconUrl: productInfo.iconUrl
    };
}
const $e69b9564388a8a7c$var$styles = {
    container: "_2rko1qi0 _1reo15vq _18m915vq _bfhki8nm _19pku2gc _irr3plhp",
    mainAction: "_zulpu2gc _1rjcu2gc _16jlkb7n _1e0c1txw _4cvr1h6o _bozgu2gc _bfhk1j28",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    dismissButton: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr31j28"
};
const $e69b9564388a8a7c$var$i18n = (0, $h82at.defineMessages)({
    addContent: {
        id: "side-navigation.space-navigation.related-content.add-content",
        defaultMessage: "Add content from your apps"
    },
    dismiss: {
        id: "side-navigation.space-navigation.related-content.dismiss",
        defaultMessage: "Dismiss related content"
    }
});
const $e69b9564388a8a7c$export$8372b97ddec977cb = (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { spaceName: spaceName, iconPath: iconPath } = t0;
    const intl = (0, $1cfRh.default)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const pageTreeStateUpdaterRef = (0, $42omo.useRef)(null);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { groups: groups, isLoading: isLoadingSuggestions, refetch: refetch } = (0, $d3bfb9815ee47511$export$b1532bcf7c9b2548)(spaceKey);
    let t1;
    if ($[0] !== groups) {
        t1 = Array.from(new Set(groups.flatMap($e69b9564388a8a7c$var$_temp).map($e69b9564388a8a7c$var$_temp2).filter($e69b9564388a8a7c$var$_temp3)));
        $[0] = groups;
        $[1] = t1;
    } else t1 = $[1];
    const iconUrls = t1;
    if ((0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || isLoadingSuggestions || groups.length === 0) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsModalOpen(true);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== iconUrls) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            iconUrls: iconUrls
        }));
        $[3] = iconUrls;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContent);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.mainAction,
            onClick: t2
        }, t3, t5);
        $[9] = t3;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsVisible(false);
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== intl) {
        t8 = intl.formatMessage($e69b9564388a8a7c$var$i18n.dismiss);
        $[13] = intl;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        });
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.dismissButton,
            onClick: t7,
            "aria-label": t8
        }, t9);
        $[16] = t8;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.container,
            testId: "space-navigation-related-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center"
        }, t6, t10));
        $[18] = t10;
        $[19] = t6;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== groups || $[22] !== iconPath || $[23] !== iconUrls || $[24] !== isModalOpen || $[25] !== refetch || $[26] !== spaceKey || $[27] !== spaceName) {
        t12 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7), {
            spaceName: spaceName,
            iconPath: iconPath,
            groups: groups,
            iconUrls: iconUrls,
            spaceKey: spaceKey,
            onClose: ()=>setIsModalOpen(false),
            onSaveSuccess: async ()=>{
                await refetch();
                setIsModalOpen(false);
                if (pageTreeStateUpdaterRef.current && groups[0]?.parentId) pageTreeStateUpdaterRef.current.setForceFetchPageId(String(groups[0].parentId));
            }
        });
        $[21] = groups;
        $[22] = iconPath;
        $[23] = iconUrls;
        $[24] = isModalOpen;
        $[25] = refetch;
        $[26] = spaceKey;
        $[27] = spaceName;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t12);
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>{
            pageTreeStateUpdaterRef.current = pageTreeStateUpdater;
            return null;
        });
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== t11 || $[33] !== t13) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t13, t14);
        $[32] = t11;
        $[33] = t13;
        $[34] = t15;
    } else t15 = $[34];
    return t15;
};
function $e69b9564388a8a7c$var$_temp(g) {
    return g.remoteObjects;
}
function $e69b9564388a8a7c$var$_temp2(s) {
    return $e69b9564388a8a7c$export$451fcc3902224a39(s.url).iconUrl;
}
function $e69b9564388a8a7c$var$_temp3(url) {
    return Boolean(url);
}





































































var $e4a87a0fae275d2a$exports = {};
$e4a87a0fae275d2a$exports = new URL("google-drive.3a58669c.svg", import.meta.url).toString();


var $c5f1592a357e181d$exports = {};
$c5f1592a357e181d$exports = new URL("microsoft-teams.4206e18c.svg", import.meta.url).toString();


var $559b6cb878c71eb1$exports = {};
$559b6cb878c71eb1$exports = new URL("loom.96da19c1.svg", import.meta.url).toString();


const $5992b073ef8023fa$var$i18n = (0, $h82at.defineMessages)({
    title: {
        id: "side-navigation.space-navigation.third-party-auth.modal.title",
        defaultMessage: "Connect apps for more suggestions"
    },
    description: {
        id: "side-navigation.space-navigation.third-party-auth.modal.description",
        defaultMessage: "Connect at least one app to see curated suggestions here."
    },
    loom: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.loom",
        defaultMessage: "Loom"
    },
    loomDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.loom.description",
        defaultMessage: "Surface videos, recordings and transcripts"
    },
    microsoftTeams: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.microsoft-teams",
        defaultMessage: "Microsoft Office"
    },
    microsoftTeamsDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.microsoft-teams.description",
        defaultMessage: "Bring in documents, presentations and files"
    },
    googleDrive: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.google-drive",
        defaultMessage: "Google Drive"
    },
    googleDriveDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.google-drive.description",
        defaultMessage: "Surface docs, sheets, slides and folders"
    },
    connect: {
        id: "side-navigation.space-navigation.third-party-auth.modal.connect",
        defaultMessage: "Connect"
    }
});
const $5992b073ef8023fa$var$OPTION_CONFIG = {
    [(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).LOOM]: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($559b6cb878c71eb1$exports))),
        labelMessage: $5992b073ef8023fa$var$i18n.loom,
        descriptionMessage: $5992b073ef8023fa$var$i18n.loomDescription,
        iconUrls: [
            (0, (/*@__PURE__*/$parcel$interopDefault($559b6cb878c71eb1$exports)))
        ]
    },
    [(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS]: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c5f1592a357e181d$exports))),
        labelMessage: $5992b073ef8023fa$var$i18n.microsoftTeams,
        descriptionMessage: $5992b073ef8023fa$var$i18n.microsoftTeamsDescription,
        iconUrls: [
            (0, (/*@__PURE__*/$parcel$interopDefault($c5f1592a357e181d$exports)))
        ]
    },
    [(0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE]: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e4a87a0fae275d2a$exports))),
        labelMessage: $5992b073ef8023fa$var$i18n.googleDrive,
        descriptionMessage: $5992b073ef8023fa$var$i18n.googleDriveDescription,
        iconUrls: [
            (0, (/*@__PURE__*/$parcel$interopDefault($e4a87a0fae275d2a$exports)))
        ]
    }
};
const $5992b073ef8023fa$var$styles = {
    layout: "_2rkopb1k _4t3i10fc",
    leftPanel: "_zulp1ejb _1rjc1jfw _18zrxy5q _16jlkb7n _i0dl1ssb _1e0c1txw _2lx21bp4 _18m91wug",
    optionRow: "_zulppxbi _2rkopb1k _1rjcpxbi _18zrpxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o",
    optionIcon: "_1bsb1tcg _4t3i1tcg _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o",
    optionLabel: "_16jlkb7n",
    rightPanel: "_1reo15vq _18m915vq _16jlkb7n _i0dl1ssb _kqswh2mm _bfhk1ymo _5fbcpb1k _1einpb1k",
    closeButtonWrapper: "_154iu2gc _1ltvu2gc"
};
const $5992b073ef8023fa$var$AuthOptionRow = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { option: option } = t0;
    const intl = (0, $1cfRh.default)();
    const { icon: icon, labelMessage: labelMessage, descriptionMessage: descriptionMessage } = $5992b073ef8023fa$var$OPTION_CONFIG[option];
    let t1;
    if ($[0] !== intl || $[1] !== labelMessage) {
        t1 = intl.formatMessage(labelMessage);
        $[0] = intl;
        $[1] = labelMessage;
        $[2] = t1;
    } else t1 = $[2];
    const label = t1;
    let t2;
    if ($[3] !== descriptionMessage || $[4] !== intl) {
        t2 = intl.formatMessage(descriptionMessage);
        $[3] = descriptionMessage;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== icon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: icon,
            alt: "",
            width: 24,
            height: 24
        }));
        $[6] = icon;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, label);
        $[8] = label;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, description);
        $[10] = description;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t4, t5));
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== intl) {
        t7 = intl.formatMessage($5992b073ef8023fa$var$i18n.connect);
        $[15] = intl;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default"
        }, t7);
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t3 || $[20] !== t6 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionRow,
            role: "listitem"
        }, t3, t6, t8);
        $[19] = t3;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $5992b073ef8023fa$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { authOptions: authOptions } = t0;
    const intl = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($5992b073ef8023fa$var$i18n.title);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium"
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage($5992b073ef8023fa$var$i18n.description);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200"
        }, t2, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== authOptions) {
        t6 = authOptions.map($5992b073ef8023fa$var$_temp);
        $[11] = authOptions;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            role: "list"
        }, t6);
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t5 || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.leftPanel
        }, t5, t7);
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
};
const $5992b073ef8023fa$var$ModalRightPanel = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.rightPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.closeButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $5992b073ef8023fa$export$adba184288a85068 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { authOptions: authOptions, onClose: onClose } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== authOptions) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$ModalLeftPanel, {
            authOptions: authOptions
        });
        $[0] = authOptions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$ModalRightPanel, null);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.layout
        }, t1, t2);
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== Modal || $[6] !== onClose || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: onClose,
            width: "90vw"
        }, t3);
        $[5] = Modal;
        $[6] = onClose;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $5992b073ef8023fa$var$_temp(option) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$AuthOptionRow, {
        key: option,
        option: option
    });
}






const $e2f9c8125fdf9a13$var$THIRD_PARTY_ICON_URLS = [
    (0, (/*@__PURE__*/$parcel$interopDefault($e4a87a0fae275d2a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c5f1592a357e181d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($559b6cb878c71eb1$exports)))
];
const $e2f9c8125fdf9a13$var$ALL_AUTH_OPTIONS = [
    (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).LOOM,
    (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS,
    (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE
];
const $e2f9c8125fdf9a13$var$styles = {
    container: "_2rko1qi0 _1reo15vq _18m915vq _bfhki8nm _19pku2gc _irr3plhp",
    mainAction: "_zulpu2gc _1rjcu2gc _16jlkb7n _1e0c1txw _4cvr1h6o _bozgu2gc _bfhk1j28",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    dismissButton: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr31j28"
};
const $e2f9c8125fdf9a13$var$i18n = (0, $h82at.defineMessages)({
    addContent: {
        id: "side-navigation.space-navigation.third-party-auth.connect-your-apps",
        defaultMessage: "Connect your apps"
    },
    dismiss: {
        id: "side-navigation.space-navigation.third-party-auth.dismiss",
        defaultMessage: "Dismiss related content"
    }
});
const $e2f9c8125fdf9a13$export$55683e4280ace85d = ()=>{
    const $ = (0, $frIzR.c)(22);
    const intl = (0, $1cfRh.default)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    if ((0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsModalOpen(true);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            iconUrls: $e2f9c8125fdf9a13$var$THIRD_PARTY_ICON_URLS
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.addContent);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.mainAction,
            onClick: t0
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t2));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsVisible(false);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== intl) {
        t5 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.dismiss);
        $[7] = intl;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        });
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.dismissButton,
            onClick: t4,
            "aria-label": t5
        }, t6);
        $[10] = t5;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.container,
            testId: "space-navigation-third-party-auth"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center"
        }, t3, t7));
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== isModalOpen) {
        t9 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5992b073ef8023fa$export$adba184288a85068), {
            authOptions: $e2f9c8125fdf9a13$var$ALL_AUTH_OPTIONS,
            onClose: ()=>setIsModalOpen(false)
        });
        $[15] = isModalOpen;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t9);
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== t10 || $[20] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t10);
        $[19] = t10;
        $[20] = t8;
        $[21] = t11;
    } else t11 = $[21];
    return t11;
};


const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete, spaceName: spaceName, iconPath: iconPath } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).LOOM,
            (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS,
            (0, $090b31fb8b21ef86$export$f0c7a43b2eefe22f).GOOGLE_DRIVE
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== cloudId) {
        t2 = {
            products: t1,
            cloudId: cloudId
        };
        $[1] = cloudId;
        $[2] = t2;
    } else t2 = $[2];
    const authResult = (0, $06f9e66a9eacf0bf$export$3d6949c2295aff10)(t2);
    let t3;
    if ($[3] !== authResult.authentications || $[4] !== authResult.isLoading) {
        t3 = !authResult.isLoading && Object.values(authResult.authentications).length > 0 && Object.values(authResult.authentications).every($72da3bb5b7695f3e$var$_temp);
        $[3] = authResult.authentications;
        $[4] = authResult.isLoading;
        $[5] = t3;
    } else t3 = $[5];
    const allUnauthenticated = t3;
    let t4;
    if ($[6] !== isSpaceAdmin || $[7] !== quick || $[8] !== showShortcutsSection || $[9] !== space?.id || $[10] !== spaceKey) {
        t4 = showShortcutsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e27872478384c0$export$7f1bcb54a9a4d80e), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        });
        $[6] = isSpaceAdmin;
        $[7] = quick;
        $[8] = showShortcutsSection;
        $[9] = space?.id;
        $[10] = spaceKey;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== allUnauthenticated || $[13] !== homepageId || $[14] !== iconPath || $[15] !== isBlogNavigation || $[16] !== loading || $[17] !== onContentTreeLoadComplete || $[18] !== onDragDropSuccess || $[19] !== pageTreeFinishedLoading || $[20] !== space?.didContainUserContent || $[21] !== spaceKey || $[22] !== spaceName) {
        t5 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree",
            onMouseEnter: (0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) ? undefined : (0, $3qtLb.PageTreeLoaderOnHover).hydrateOnHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            relatedContent: allUnauthenticated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2f9c8125fdf9a13$export$55683e4280ace85d), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e69b9564388a8a7c$export$8372b97ddec977cb), {
                spaceName: spaceName,
                iconPath: iconPath
            })
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[12] = allUnauthenticated;
        $[13] = homepageId;
        $[14] = iconPath;
        $[15] = isBlogNavigation;
        $[16] = loading;
        $[17] = onContentTreeLoadComplete;
        $[18] = onDragDropSuccess;
        $[19] = pageTreeFinishedLoading;
        $[20] = space?.didContainUserContent;
        $[21] = spaceKey;
        $[22] = spaceName;
        $[23] = t5;
    } else t5 = $[23];
    let t6;
    if ($[24] !== blogsHidden || $[25] !== loading || $[26] !== pageTreeFinishedLoading || $[27] !== spaceKey) {
        t6 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2956b96ada85ef60$export$a2e535ad780a85fe), {
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        });
        $[24] = blogsHidden;
        $[25] = loading;
        $[26] = pageTreeFinishedLoading;
        $[27] = spaceKey;
        $[28] = t6;
    } else t6 = $[28];
    let t7;
    if ($[29] !== t4 || $[30] !== t5 || $[31] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t5, t6);
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
    } else t7 = $[32];
    return t7;
};
function $72da3bb5b7695f3e$var$_temp(status) {
    return !status.isAuthenticated;
}
module.exports["CommonSpaceNavigationContent"] = $72da3bb5b7695f3e$export$7716f65eb5d1a3fd;

});

parcelRegister("eLeAP", function(module, exports) {

let $abf0c651698297f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abf0c651698297f1$var$load("4Nzvy"),
    $abf0c651698297f1$var$load("6wr18"),
    $abf0c651698297f1$var$load("fLZBc"),
    $abf0c651698297f1$var$load("bg5OF"),
    $abf0c651698297f1$var$load("8YSo7"),
    $abf0c651698297f1$var$load("aiWbc"),
    $abf0c651698297f1$var$load("Wowvf"),
    $abf0c651698297f1$var$load("hhss7"),
    $abf0c651698297f1$var$load("ffEVr"),
    $abf0c651698297f1$var$load("jXx9i"),
    $abf0c651698297f1$var$load("hIyTB"),
    $abf0c651698297f1$var$load("9Hn5Z"),
    $abf0c651698297f1$var$load("jY21r"),
    $abf0c651698297f1$var$load("hogcU"),
    $abf0c651698297f1$var$load("7KZeZ"),
    $abf0c651698297f1$var$load("8Vzcw"),
    $abf0c651698297f1$var$load("co52j"),
    $abf0c651698297f1$var$load("77NEU"),
    $abf0c651698297f1$var$load("cpQv0"),
    $abf0c651698297f1$var$load("7EorR"),
    $abf0c651698297f1$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("hZJql", function(module, exports) {

let $d19b5e7027d66a93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d19b5e7027d66a93$var$load("jBVuy"),
    $d19b5e7027d66a93$var$load("adFHx"),
    $d19b5e7027d66a93$var$load("6wr18"),
    $d19b5e7027d66a93$var$load("4dNRa"),
    $d19b5e7027d66a93$var$load("1GCFv"),
    $d19b5e7027d66a93$var$load("a9w2G"),
    $d19b5e7027d66a93$var$load("k2R9e"),
    $d19b5e7027d66a93$var$load("7kkP6"),
    $d19b5e7027d66a93$var$load("h4Nf7"),
    $d19b5e7027d66a93$var$load("jbxHq"),
    $d19b5e7027d66a93$var$load("8Fbef"),
    $d19b5e7027d66a93$var$load("3WB19"),
    $d19b5e7027d66a93$var$load("hv4mn"),
    $d19b5e7027d66a93$var$load("cyGuT"),
    $d19b5e7027d66a93$var$load("ffEVr"),
    $d19b5e7027d66a93$var$load("hhss7"),
    $d19b5e7027d66a93$var$load("jY21r"),
    $d19b5e7027d66a93$var$load("7KZeZ"),
    $d19b5e7027d66a93$var$load("4izLy"),
    $d19b5e7027d66a93$var$load("7EorR"),
    $d19b5e7027d66a93$var$load("Wowvf"),
    $d19b5e7027d66a93$var$load("4Nzvy"),
    $d19b5e7027d66a93$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<1e99a80971f27cbfb1a191a696e406fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<6565ef7fe5ad6d9aeb4c2193c86bde80>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;



var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $h82at.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified.nonfinal",
        // Remove .nonfinal suffix when copy is finalized
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isLicensed
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation);
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039)
    });
    const setSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: queryLoading,
        queryError: queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c4de3c3a60bbeec4$var$buttonStyle = null;
const $c4de3c3a60bbeec4$var$menuButtonIconColor = (isWhiteboardBetaEnabled)=>{
    return isWhiteboardBetaEnabled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$266a769812832828 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_s1xtjf": (0, $7sObp.default)($c4de3c3a60bbeec4$var$menuButtonIconColor(__cmplp.isWhiteboardBetaEnabled))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _bfhk1j28 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _i2zu1q3r _19lcplhp",
            __cmplp.isOpen ? "_1efs18pu" : "_1efsdgkc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8wadc _ca0qt94y _u5f31l7b _n3tdt94y _19bv1l7b _bfhki8nm _syazi7uo _k48pwu06",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$11b902a59791d036 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8wo40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$851411cf794a4cc4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1y44 _2hwx1y44 _otyr1y44 _18u0ftgi _2rko1rr0 _1yt418iy _19itglyw _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _bfhk1s93 _syaz1oa5 _1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _18s817d0 _11c8fhey _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _4t3imgvx _syazi7uo",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("lav2O", function(module, exports) {

let $f6929ceacdcf6e28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6929ceacdcf6e28$var$load("kHOMt"),
    $f6929ceacdcf6e28$var$load("4izLy"),
    $f6929ceacdcf6e28$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("kUixh", function(module, exports) {

let $f3876a711782b5e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3876a711782b5e6$var$load("kFEyO"),
    $f3876a711782b5e6$var$load("dndbG"),
    $f3876a711782b5e6$var$load("15N8O"),
    $f3876a711782b5e6$var$load("QDkFg"),
    $f3876a711782b5e6$var$load("hhss7"),
    $f3876a711782b5e6$var$load("jd7Mc"),
    $f3876a711782b5e6$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("loCxh", function(module, exports) {

let $f939bb4a445c4f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f939bb4a445c4f6b$var$load("6wr18"),
    $f939bb4a445c4f6b$var$load("aoGyu"),
    $f939bb4a445c4f6b$var$load("ffEVr"),
    $f939bb4a445c4f6b$var$load("Wowvf"),
    $f939bb4a445c4f6b$var$load("4mgLr"),
    $f939bb4a445c4f6b$var$load("hhss7"),
    $f939bb4a445c4f6b$var$load("7EorR"),
    $f939bb4a445c4f6b$var$load("kJLy8"),
    $f939bb4a445c4f6b$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("c2Apt", function(module, exports) {

let $8c41ea3346a639fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c41ea3346a639fa$var$load("6wr18"),
    $8c41ea3346a639fa$var$load("e4XZ1"),
    $8c41ea3346a639fa$var$load("5ppK3"),
    $8c41ea3346a639fa$var$load("hhss7"),
    $8c41ea3346a639fa$var$load("ffEVr"),
    $8c41ea3346a639fa$var$load("iNa18"),
    $8c41ea3346a639fa$var$load("aiWbc"),
    $8c41ea3346a639fa$var$load("5dBst"),
    $8c41ea3346a639fa$var$load("7EorR"),
    $8c41ea3346a639fa$var$load("7KZeZ"),
    $8c41ea3346a639fa$var$load("8Vzcw"),
    $8c41ea3346a639fa$var$load("co52j"),
    $8c41ea3346a639fa$var$load("4izLy"),
    $8c41ea3346a639fa$var$load("Wowvf"),
    $8c41ea3346a639fa$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("d1wmn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $dbff9ae313f922d4$export$94fe6747d9c16142 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "5XxyI",
    name: "ExternalCollaboratorInSpaceNotify",
    loader: async ()=>(await (parcelRequire("cv79u"))).ExternalCollaboratorInSpaceNotify
});
module.exports["ExternalCollaboratorInSpaceNotify"] = $dbff9ae313f922d4$export$94fe6747d9c16142;

});

parcelRegister("cv79u", function(module, exports) {

let $919ded8346cfe216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $919ded8346cfe216$var$load("lnCW7").then(()=>parcelRequire('j8dZ5'));

});

parcelRegister("joey7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4343b3f26acaf51e$export$9c01e508282d4bd5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "U1K88",
    name: "GuestOnboardingModalLoadable",
    loader: async ()=>(await (parcelRequire("Hp5aQ"))).GuestOnboardingModal
});
module.exports["GuestOnboardingModalLoadable"] = $4343b3f26acaf51e$export$9c01e508282d4bd5;

});

parcelRegister("Hp5aQ", function(module, exports) {

let $0827791e94ebd627$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0827791e94ebd627$var$load("hhss7"),
    $0827791e94ebd627$var$load("7Ni3R")
]).then(()=>parcelRequire('jb3az'));

});


//# sourceMappingURL=Nav3SpaceNavigationContent.58ab1b1f.js.map
